import { getCurrentInstance } from "vue";
import { isArray, isString, camelize } from "@vue/shared";
export const isNumber = (val: unknown): val is number =>
  typeof val === "number";
export { isArray, isString, camelize };

export function useGlobalConfig() {
  const vm: any = getCurrentInstance();
  if ("$GPLUS" in vm.proxy) {
    return vm.proxy.$GPLUS;
  }
  return {};
}

export const isMeaningful = (object: string) =>
  object !== null && object !== undefined && object !== "";
